export const COMPLEX_EMAIL_TOOLBAR = {
  PREVIEW_AND_TEST_BUTTON:{
    key: 'PREVIEW_AND_TEST_BUTTON',
    value: 'Preview & Test',
  },
  EXIT_PREVIEW_AND_TEST_BUTTON:{
    key: 'EXIT_PREVIEW_AND_TEST_BUTTON',
    value: 'Exit Preview & Test',
  },
  PREVIEW_AND_SEND_BUTTON:{
    key: 'PREVIEW_AND_SEND_BUTTON',
    value: 'Preview & Send',
  },
  EXIT_PREVIEW_AND_SEND_BUTTON:{
    key: 'EXIT_PREVIEW_AND_SEND_BUTTON',
    value: 'Exit Preview & Send',
  },
  PREVIEW_BUTTON: {
    key: 'PREVIEW_BUTTON',
    value: 'Preview',
  },
  EXIT_PREVIEW_BUTTON: {
    key: 'EXIT_PREVIEW_BUTTON',
    value: 'Exit Preview',
  },
}

export const COMPLEX_EMAIL_SETTINGS = {
  UPDATE_FROM_ADDRESS_SUCCESS: {
    key: 'UPDATE_FROM_ADDRESS_SUCCESS',
    value: "From address changed successfully!"
  },
  UPDATE_FROM_ADDRESS_FAILURE: {
    key: 'UPDATE_FROM_ADDRESS_FAILURE',
    value: "Unable to change from address, Please try again later"
  },
  ADD_ATTACHMENT_SUCCESSFUL: {
    key: 'ADD_ATTACHMENT_SUCCESSFUL',
    value: 'Attachment added successfully!!!'
  },
  ADD_ATTACHMENT_FAILURE: {
    key: 'ADD_ATTACHMENT_FAILURE',
    value: 'Unable to add attachment, Please try again later'
  },
  DELETE_ATTACHMENT_SUCCESSFUL: {
    key: 'DELETE_ATTACHMENT_SUCCESSFUL',
    value: "Attachment deleted successfully!"
  },
  DELETE_ATTACHMENT_FAILURE: {
    key: 'DELETE_ATTACHMENT_FAILURE',
    value: 'Unable to delete attachment, Please try again later'
  },
  PASSWORD_PROTECT_SUCCESS: {
    key: 'PASSWORD_PROTECT_SUCCESS',
    value: "Attachment updated successfully!"
  },
  PASSWORD_PROTECT_FAILURE: {
    key: 'PASSWORD_PROTECT_FAILURE',
    value: 'Unable to update attachment, Please try again later'
  },
  CONTENT_STYLING_HEADING: {
    key: 'CONTENT_STYLING_HEADING',
    value: 'Content Styling'
  },
  MAXIMUM_WIDTH_OF_CONTENT_LABEL: {
    key: 'MAXIMUM_WIDTH_OF_CONTENT_LABEL',
    value: 'Maximum width of content'
  },
  EMAIL_BACKGROUND_LABEL: {
    key: 'EMAIL_BACKGROUND_LABEL',
    value: 'Email Background'
  },
  CONTENT_BACKGROUND_LABEL: {
    key: 'CONTENT_BACKGROUND_LABEL',
    value: 'Content background'
  },
  DEFAULT_EMAIL_FONT_FAMILY_LABEL: {
    key: 'DEFAULT_EMAIL_FONT_FAMILY_LABEL',
    value: 'Font family'
  },
  DEFAULT_EMAIL_FONT_SIZE_LABEL: {
    key: 'DEFAULT_EMAIL_FONT_SIZE_LABEL',
    value: 'Font Size'
  },
  TOP_LABEL: {
    key: 'TOP_LABEL',
    value: 'Top'
  },
  BOTTOM_LABEL: {
    key: 'BOTTOM_LABEL',
    value: 'Bottom'
  },
  LEFT_LABEL: {
    key: 'LEFT_LABEL',
    value: 'Left'
  },
  RIGHT_LABEL: {
    key: 'RIGHT_LABEL',
    value: 'Right'
  },
  EXTERNAL_DROPDOWN_OPTION: { key: 'EXTERNAL_DROPDOWN_OPTION', value: 'External' },
  MIN_EMAIL_WIDTH_WARNING: {
    key: 'MIN_EMAIL_WIDTH_WARNING',
    value: 'According to email standards, the minimum width for emails should be 590px. Please adjust the width and try again.'
  },
  MAX_EMAIL_WIDTH_WARNING: {
    key: 'MAX_EMAIL_WIDTH_WARNING',
    value: 'According to email standards, the maximum width for emails should be 800px. Please adjust the width and try again.'
  },
  SETTINGS_TAB: {
    key: 'SETTINGS_TAB',
    value: 'Settings'
  },
  ACCESSIBILITY_SUMMARY: {
    key: 'EMAIL_SUMMARY',
    value: 'Email Summary'
  },
  ACCESSIBILITY_SUMMARY_TOOLTIP: {
    key: 'ACCESSIBILITY_SUMMARY_TOOLTIP',
    value: 'Provide a summary that helps the screen readers understand this email.'
  },
  READ_AS_SUMMARY_TOOLTIP: {
    key: 'READ_AS_SUMMARY_TOOLTIP',
    value: 'Provide alternative text to help screen readers convey the meaning of this content.'
  },
  ATTACHMENT_ALREADY_EXISTS: {
    key: 'ATTACHMENT_ALREADY_EXISTS',
    value: 'The template is already attached'
  },
  EDITABLE_CANNOT_ATTACHED: {
    key: 'EDITABLE_CANNOT_ATTACHED',
    value: 'Editable template cannot be attached with a Non Editable template'
  },
  INTERACTIVE_TEMPLATE_ATTACHED: {
    key: 'INTERACTIVE_TEMPLATE_ATTACHED',
    value: 'An Editable template is already attached, cannot attach a Non Editable template'
  },
  ONLY_ONE_EDITABLE_ALLOWED: {
    key: 'ONLY_ONE_EDITABLE_ALLOWED',
    value: 'Only one Editable template can be attached'
  }
};

export const EMAIL_TEMPLATE_TAB_DETAILS = {
  REPLACE_TEMPLATE_NO_BUTTON:{ key: "REPLACE_TEMPLATE_NO_BUTTON", value: 'NO' },
  REPLACE_TEMPLATE_YES_BUTTON:{ key: "REPLACE_TEMPLATE_YES_BUTTON", value: 'YES' },
  REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE:{ key: "REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE", value: 'YES' },
  REPLACE_TEMPLATE_TITLE:{ key: "REPLACE_TEMPLATE_TITLE", value: 'Replace template' },
};

export const COMPLEX_EMAIL_PREVIEW_SETTINGS = {
  SWITCH_TO_MOBILE_VIEW: {
    key: 'SWITCH_TO_MOBILE_VIEW',
    value: 'Switch to mobile view'
  },
  SWITCH_TO_TABLET_VIEW: {
    key: 'SWITCH_TO_TABLET_VIEW',
    value: 'Switch to tablet view'
  },
  SWITCH_TO_DESKTOP_VIEW: {
    key: 'SWITCH_TO_DESKTOP_VIEW',
    value: 'Switch to desktop view'
  }
}
export const COMPLEX_EMAIL_LAYOUT_SETTINGS = {
  PAGE_SETTING_HEADER: {
    key: 'PAGE_SETTING_HEADER',
    value: 'Email settings'
  },
  PAGE_SETTING_BUTTON: {
    key: 'PAGE_SETTING_BUTTON',
    value: 'Email settings'
  },
  FONT_FAMILY: { key: 'FONT_FAMILY', value:'Font Family' },
  FONT_SIZE: { key: 'FONT_SIZE', value: 'Font Size' }
}

export const EMAIL_TEMPLATES_MENUBAR = {
  EXPORT_EMAIL_LABEL: {
    key: 'EXPORT_EMAIL_LABEL',
    value: 'Export email',
  },
  IMPORT_EMAIL_LABEL: {
    key: 'IMPORT_EMAIL_LABEL',
    value: 'Import email',
  },
  EMAIL_EXPORT_ERROR: {
    key: 'EMAIL_EXPORT_ERROR',
    value: 'There is an issue with email export. Please try again.',
  },
  EMAIL_IMPORT_ERROR: {
    key: 'EMAIL_IMPORT_ERROR',
    value: 'There is an issue with email import. Please try again.',
  },
  EMAIL_SUBJECT_ERROR: {
    key: 'EMAIL_SUBJECT_ERROR',
    value: 'Email Subject is missing',
  },
};
